export default __webpack_public_path__ + "static/media/6-6.01c75be2.png";